import React from 'react';
import './header.scss';

const Header = () => {
  return (
    <header>
      <ul>
        <li>
          <a href="/"
            alt="compare places"
          >
            <img src={require('../../assets/gocompare.svg')} alt="logo" className="logo"/>
            Place Compare
          </a>
        </li>
      </ul>
    </header>
  )
}
export default Header;